import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminReportsService } from '../core/services/admin-reports.service';
import { AdminReports } from '../core/models/admin.models';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  reports: AdminReports | null = null;
  isLoading = false;
  errorMessage = '';

  constructor(private reportsService: AdminReportsService) {}

  ngOnInit() {
    this.loadReports();
  }

  loadReports() {
    this.isLoading = true;
    this.errorMessage = '';

    this.reportsService.getReports().subscribe({
      next: (data: AdminReports) => {
        this.reports = data;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load reports.';
        this.isLoading = false;
      }
    });
  }
}

